<div class="na-container">
  <app-title-container backPath="/assessments">
    <h1>New Assessment</h1>
  </app-title-container>
  <app-divider height="2px"></app-divider>
  @if (isInitDataLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div class="na-content-container">
      <app-insights-access-banner message="Sign in to Insights before creating an assessment to generate ESG Insights." />
      <form [formGroup]="assessmentForm" class="na-form" (ngSubmit)="onSubmit()">
        @if (dealUrl()) {
          <div class="three-column-layout">
            <div class="side-column">
              <mat-form-field>
                <mat-label>Deal Url</mat-label>
                <input matInput formControlName="dealUrl" />
              </mat-form-field>
            </div>
            <div class="icon-column"></div>
            <div class="side-column"></div>
          </div>
        }

        @if (DealSource()) {
          <div class="three-column-layout">
            <div class="side-column">
              <mat-form-field>
                <mat-label>Deal Source System</mat-label>
                <input matInput formControlName="dealSourceSystem" />
              </mat-form-field>
            </div>
            <div class="icon-column"></div>
            <div class="side-column"></div>
          </div>
        }

        <div class="three-column-layout">
          <div class="side-column">
            <mat-form-field>
              <mat-label>Deal Id (optional)</mat-label>
              <input matInput formControlName="dealSourceSystemId" />
            </mat-form-field>
          </div>
          <div class="icon-column"></div>
          <div class="side-column"></div>
        </div>

        <div class="form-item">
          <mat-checkbox formControlName="isLH">for Life, Accident & Health</mat-checkbox>
          <span class="material-symbols-outlined info" [matTooltip]="toolTips().lhTooltip" matTooltipClass="multi-line-tooltip">
            info
          </span>
          <mat-checkbox formControlName="isThirdParty" class="checkbox-inline-gap">for Third Parties (e.g. vendors)</mat-checkbox>
          <span class="material-symbols-outlined info" [matTooltip]="toolTips().thirdPartyTooltip" matTooltipClass="multi-line-tooltip">
            info
          </span>
        </div>

        <div class="three-column-layout">
          <div class="side-column">
            <app-improved-select
              formControlName="countries"
              [optionList]="countries()"
              [multiple]="true"
              [showChips]="true"
              label="Country of risk location"
              displayKey="name"
            >
            </app-improved-select>
            @if (assessmentForm.get('countries')?.hasError('maxSelection')) {
              <mat-error> You can select up to {{ MAX_SELECTION }} countries. </mat-error>
            }
          </div>
          <div class="icon-column info-icon">
            <span class="material-symbols-outlined" [matTooltip]="toolTips().countryTooltip" matTooltipClass="multi-line-tooltip">
              info
            </span>
          </div>
          <div class="side-column"></div>
        </div>

        <div class="three-column-layout">
          <div class="side-column">
            <app-improved-select formControlName="sector" [optionList]="sectors()" label="Sector" displayKey="name" valueKey="sdlId">
            </app-improved-select>
          </div>
          <div class="icon-column info-icon">
            <span class="material-symbols-outlined" [matTooltip]="toolTips().sectorTooltip" matTooltipClass="multi-line-tooltip">
              info
            </span>
          </div>
          <div class="side-column"></div>
        </div>

        <div class="three-column-layout">
          <div class="side-column">
            <app-improved-select
              formControlName="company"
              [optionList]="companies()"
              label="Company"
              displayKey="name"
              valueKey="sdlId"
            ></app-improved-select>
          </div>
          <div class="icon-column info-icon">
            <span class="material-symbols-outlined" [matTooltip]="toolTips().companyTooltip" matTooltipClass="multi-line-tooltip">
              info
            </span>
          </div>
          <div class="side-column">
            @if (isOtherCompany()) {
              <mat-form-field hideRequiredMarker="true">
                <mat-label>Other Company</mat-label>
                <input matInput formControlName="otherCompany" />
              </mat-form-field>
            }
          </div>
        </div>

        <div class="three-column-layout">
          <div class="side-column">
            <app-improved-select formControlName="project" [optionList]="projects()" label="Project" displayKey="name" valueKey="sdlId">
            </app-improved-select>
          </div>
          <div class="icon-column info-icon">
            <span class="material-symbols-outlined" [matTooltip]="toolTips().projectTooltip" matTooltipClass="multi-line-tooltip">
              info
            </span>
          </div>
          <div class="side-column">
            @if (isOtherProject()) {
              <mat-form-field>
                <mat-label>Other Project</mat-label>
                <input matInput formControlName="otherProject" />
              </mat-form-field>
            }
          </div>
        </div>

        <div class="coordinates-section">
          <div class="pa-label-container">
            <h4>
              Protected Area Check (optional)
              <span class="material-symbols-outlined pa-info-icon" [matTooltip]="PA_TOOLTIP_TEXT" matTooltipClass="multi-line-tooltip">
                info
              </span>
            </h4>
          </div>

          <div class="coordinates-bulk-btns">
            <button mat-button color="primary" type="button" (click)="downloadPATemplate()">
              <mat-icon fontSet="material-symbols-outlined">file_save</mat-icon>
              Protected Area Template - Download
            </button>

            @if (!isTopLimit()) {
              <input #fileInputUpload hidden type="file" accept=".xls,.xlsx" (change)="addBulkCoordinates($event, fileInputUpload)" />
              <button
                matButton="outlined"
                class="coordinates-bulk-upload-btn"
                type="button"
                [disabled]="isBulkCoordinatesLoading()"
                (click)="fileInputUpload.click()"
              >
                @if (isBulkCoordinatesLoading()) {
                  <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon>
                } @else {
                  <mat-icon fontSet="material-symbols-outlined">upload</mat-icon>
                }
                <span>Bulk Upload</span>
              </button>
            }
          </div>

          <div class="number-of-coordinates-text mat-body-small">
            {{ numberOfCoordinatesText() }}
          </div>

          @if (isAtLeastOneCoordinate()) {
            <cdk-virtual-scroll-viewport
              class="coordinates-viewport"
              itemSize="65"
              [style.height.px]="getViewportHeight()"
              formArrayName="protectedAreaCoordinates"
            >
              <div
                class="coordinate-row"
                *cdkVirtualFor="let coordinateGroup of coordinateControls(); let i = index; trackBy: trackByGroupId; templateCacheSize: 0"
                [formGroupName]="i"
              >
                <div class="coordinate">
                  <div class="coordinate-fields">
                    <mat-form-field class="coordinate-fields-item" hideRequiredMarker="true">
                      <mat-label>Property Name</mat-label>
                      <input matInput formControlName="propertyName" />
                      @if (coordinateGroup.get('propertyName')?.hasError('required')) {
                        <mat-error> Property name is required </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="coordinate-fields-item" hideRequiredMarker="true">
                      <mat-label>Latitude</mat-label>
                      <input matInput formControlName="latitude" />
                      @if (coordinateGroup.get('latitude')?.hasError('required')) {
                        <mat-error> Latitude is required </mat-error>
                      }
                      @if (coordinateGroup.get('latitude')?.hasError('notNumber')) {
                        <mat-error>Not a number</mat-error>
                      }
                      @if (coordinateGroup.get('latitude')?.hasError('outOfRange')) {
                        <mat-error> Must be between -90 and 90</mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="coordinate-fields-item" hideRequiredMarker="true">
                      <mat-label>Longitude</mat-label>
                      <input matInput formControlName="longitude" />
                      @if (coordinateGroup.get('longitude')?.hasError('required')) {
                        <mat-error> Longitude is required </mat-error>
                      }
                      @if (coordinateGroup.get('longitude')?.hasError('notNumber')) {
                        <mat-error>Not a number</mat-error>
                      }
                      @if (coordinateGroup.get('longitude')?.hasError('outOfRange')) {
                        <mat-error> Must be between -180 and 180</mat-error>
                      }
                    </mat-form-field>
                    <button
                      mat-icon-button
                      color="warn"
                      type="button"
                      (click)="removeCoordinateGroup(i)"
                      class="remove-coordinate-btn"
                      aria-label="Remove coordinate pair"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          } @else {
            <div class="coordinates-viewport">
              <div class="coordinate-row">
                <div class="coordinate">
                  <div class="coordinate-fields">
                    <mat-form-field class="coordinate-fields-item" hideRequiredMarker="true">
                      <mat-label>Property Name</mat-label>
                      <input matInput disabled placeholder="Property Name" />
                    </mat-form-field>
                    <mat-form-field class="coordinate-fields-item" hideRequiredMarker="true">
                      <mat-label>Latitude</mat-label>
                      <input matInput disabled placeholder="Latitude" />
                    </mat-form-field>
                    <mat-form-field class="coordinate-fields-item" hideRequiredMarker="true">
                      <mat-label>Longitude</mat-label>
                      <input matInput disabled placeholder="Longitude" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (!isTopLimit()) {
            <button class="add-coordinate-btn" matButton="outlined" type="button" (click)="addCoordinateGroup()">
              <mat-icon>add</mat-icon>
              <span>Add Single-Location Check</span>
            </button>
          }
          @if (isAtLeastOneCoordinate()) {
            <button mat-button class="coordinates-delete-all-btn" type="button" (click)="removeAllCoordinateGroups()">
              <mat-icon>delete_outline</mat-icon>
              <span>Delete All</span>
            </button>
          }
        </div>

        <div class="btn-container with-other-fields">
          <button
            class="submit-btn"
            mat-flat-button
            color="primary"
            [disabled]="assessmentForm.invalid || isCompanyLoading() || isProjectLoading() || isCreationLoading()"
            type="submit"
          >
            @if (isCreationLoading()) {
              <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon>
            } @else {
              <mat-icon>check</mat-icon>
            }
            <span>Submit</span>
          </button>
        </div>
      </form>
    </div>
  }
</div>
